import { render } from "./loading.vue?vue&type=template&id=3214c6ba&scoped=true"
import script from "./loading.vue?vue&type=script&lang=js"
export * from "./loading.vue?vue&type=script&lang=js"

import "./loading.vue?vue&type=style&index=0&id=3214c6ba&scoped=true&lang=css"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3214c6ba"]])

export default __exports__